<form [formGroup]="form()">
    <div class="grid grid-cols-1 gap-4 mb-4">
        
        <spike-field-text 
            formControlName="shortDescription" 
            label="Titolo Investimento" 
            placeholder="Es: Acquisto Apple Inc.">
        </spike-field-text>

        <spike-field-date 
            formControlName="accountingDate" 
            label="Data Operazione" 
            placeholder="Seleziona data">
        </spike-field-date>

        <spike-field-select 
            label="Wallet" 
            [initialValue]="walletStoreService.findReactive(form().controls['finWalletId'].value)()" 
            formControlName="finWalletId" 
            selectKey="finWalletId" 
            selectValue="shortDescription" 
            listTitle="Seleziona Wallet" 
            detailTitle="Dettaglio wallet">
            <ng-template #list>
                <spike-wallet-list #listRef [list]="walletStoreService.getList()()"/>
            </ng-template>
        </spike-field-select>

        @if(investmentType()!==3){
            <spike-field-wrapper label="Quantità" labelFor="quantity"  >
                <p-inputnumber formControlName="quantity"  inputId="quantity" mode="decimal" placeholder="0.0000" [minFractionDigits]="0" [maxFractionDigits]="5"/>
            </spike-field-wrapper>
        }

        <spike-field-wrapper label="Prezzo Unitario" labelFor="purchaseValue"  >
            <p-inputnumber formControlName="purchaseValue"  inputId="purchaseValue" mode="decimal" placeholder="0.0000" [minFractionDigits]="0" [maxFractionDigits]="5"/>
        </spike-field-wrapper>

        <spike-field-number 
            formControlName="commissionCost" 
            label="Commissioni"
            mode="currency" 
            currency="EUR" 
            placeholder="0.00">
        </spike-field-number>

        @if(investmentType()==1){
        <div class="flex items-center gap-2 p-2">
            <input type="checkbox" formControlName="contestualCredit" id="contestualCredit">
            <label for="contestualCredit">Credito Contestuale</label>
        </div>
        }

        <spike-field-text-area 
            formControlName="description" 
            label="Note" 
            placeholder="Dettagli aggiuntivi sull'investimento...">
        </spike-field-text-area>


        {{totalValue()}}
    </div>
</form>